/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { barredLocationSchema } from './barred-location-schema';
import { candidateSchema } from './candidate-schema';

export const candidatesBarredLocationSchema: z.AnyZodObject = z.object({
  barredLocation: z.lazy(() => barredLocationSchema).nullish(),
  barredLocationId: z.string().uuid().nullish(),
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  updatedAt: z.string().datetime().nullish(),
});

export type CandidatesBarredLocation = z.infer<typeof candidatesBarredLocationSchema>;
